<template>
  <div class="FixedBottom">
    <a id="dial" href="tel:4006882000"
      ><button class="phoneBtn">
        <img src="//gw-static.qianlima.com/0cdn/static/front/qlmBidding_static_template/img/wap/phone.png" />电话咨询
      </button></a
    >
    <a href="//wap.qianlima.com/register.jsp"
      ><button class="viewBtn">
        <img src="//gw-static.qianlima.com/0cdn/static/front/qlmBidding_static_template/img/wap/view.png" />免费查询
      </button></a
    >
  </div>
</template>

<script>
export default {
  name: "FixedBottom",
};
</script>

<style lang="scss">
.FixedBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    width: 140px;
    height: 34px;
    border-radius: 18px;
    border-style: none;
    background-color: #e50012;
    color: #fff;
    img {
      width: 18px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
